let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("9Z0Ia")).then(() => parcelRequire('1Hqud'));